import { Component, OnInit } from '@angular/core';
import { CryptoService } from '@bt/core/services/crypto.service';
import { TransactionModel } from '@bt/core/models/transaction.Model';
import { NotifierService } from 'angular-notifier';
import { BaseComponent } from '@bt/core';
import { TransactionFilter } from '@bt/core/models/transactionFilter.model';
import {faArrowRight} from '@fortawesome/free-solid-svg-icons';
import * as $ from 'jquery';

@Component({
  selector: 'app-transactions',
  templateUrl: './transactions.component.html',
  styleUrls: ['./transactions.component.scss']
})
export class TransactionsComponent extends BaseComponent {
  faArrowRight= faArrowRight;
  public transactions: TransactionModel[];
  public hasInfo:boolean;
  public wallets: string[];
  public walletTypeOptions : any;
  public configLabel: any;
  public configValue: any;
  public filter: TransactionFilter;
  public isResponced: boolean;
  public defaultDate:any;
  public transactionTypes: any[];


  constructor(private cryptoService: CryptoService,
    private notifierService: NotifierService) {
        super();
        this.transactions = new Array<TransactionModel>();
        this.hasInfo = false;
        this.filter = new TransactionFilter();
        this.filter.walletType = "";
        this.filter.transactionDateStart = null;
        this.filter.transactionDateEnd = null; 
        this.filter.type = 0;
        this.isResponced = false;
        this.transactionTypes = [
           { value: 0, label: "Все типы" },
           { value: 1, label: "Пополнение" },
           { value: -1, label: "Вывод" },
         ];

        this.configLabel = {
          labelField: 'label',
          valueField: 'label',
          searchField: 'label',
          highlight: false,
          create:false,
          persist:true,
          dropdownDirection: 'down',
          
         // maxItems: 1,
          render: {
            option: function(item, escape) {
              if(item.label =="Все валюты"){
                return '<div class="option">' +
                '<span>'+escape(item.label)+'</span>' +
                '</div>';

              }
              return '<div class="option">' +
                '<img src="../../assets/img/crypto/'+item.label+'.png" alt="'+escape(item.label)+'" height="20" width="20">' +
                '<span style="margin-left:  5px; ">'+escape(item.label)+'</span>' +
                '</div>';
            },
            item: function(item, escape) {
              if(item.label =="Все валюты"){
                return '<div class="option">' +
                '<span>'+escape(item.label)+'</span>' +
                '</div>';

              }
      
              return '<div class="item">'+
              '<img src="../../assets/img/crypto/'+item.label+'.png" alt="'+escape(item.label)+'" height="20" width="20">'+
              '<span style="margin-left:  5px; ">'+escape(item.label)+'</span>' + 
              '</div>';
            }
          }
        };

        this.configValue = {
          labelField: 'label',
          valueField: 'value',
          searchField: 'label',
          highlight: false,
          create:false,
          persist:true,
          dropdownDirection: 'down',
          maxItems: 1
        };
     }

  ngOnInit() {
    this.getTransactions();
    this.InitFilterOnWalets();
    var me = this;
    var dp1 = (<any>window).$('.regDate').datepicker({
      multipleDates: true,

      autoClose: true,
      onSelect: function (fd, dates, inst) {
        if(dates){
          me.defaultDate=dates[0];
          me.filter.transactionDateStart = dates[0];
          
        if (dates.length > 1) {
          me.filter.transactionDateEnd = dates[1];
        }
        
      }
      me.getTransactions();
      }

    }).data('datepicker');
    
    var resizeTimer;

    var positionCalendarTopBottom = function(){
      var dp1Update = (<any>window).$('.regDate').datepicker().data('datepicker');

      if(dp1Update){
        if ($(window).innerWidth() < 768 ){
            dp1Update.update({
              position: "top left",
            });
        }
        else {
          dp1Update.update({
            position: "bottom left",
          });
        }
    }

    }

    $(window).on('resize', function(e) {
    
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(positionCalendarTopBottom, 250);
    
    });

    setTimeout(positionCalendarTopBottom, 250);


    (<any>window).$(".regDate").keyup(function () {
      if (!this.value || this.length < 1) {
        me.filter.transactionDateStart = null;
        me.filter.transactionDateEnd = null;
      }
    });
  }
  public clearRegDate (){
    (<any>window).$(".regDate").val("");
    this.filter.transactionDateEnd = null;
    this.filter.transactionDateStart = null;
    (<any>window).$('.regDate').datepicker().data('datepicker').clear();
    this.getTransactions();
}
  public getTransactions(){
    this.setLoading(true);
    /////////////////////костыль для того что бы время на бек приходило без смещения на 3 часа
    if(this.filter.transactionDateStart!=null && this.filter.transactionDateStart instanceof Date){
      try{
        this.filter.transactionDateStart=(<any>this).filter.transactionDateStart.toDateString();
      }
      catch{
        this.filter.transactionDateStart=null;
        this.setLoading(false);
        this.getTransactions();
      }
     
    }
    if(this.filter.transactionDateEnd!=null && this.filter.transactionDateEnd instanceof Date)
      this.filter.transactionDateEnd=(<any>this).filter.transactionDateEnd.toDateString();
    /////////////////////////1
    this.cryptoService.getAllTransactions(this.filter)
    .then((resp: any) => {
      if(resp.data.length != 0){
        this.hasInfo = true;
      }
      else{
        this.hasInfo = false;
      }
      this.transactions = resp.data;
      this.isResponced = true;
      this.setLoading(false);
    })
    .catch((error: any) => {
      this.setLoading(false);
      this.isResponced = true;
      this.notifierService.notify('error', error.error.Msgs[0]);
    });
    
  }

  public setWalletOptions(array:any){
    array.forEach(element => {
      this.walletTypeOptions.push({label:element});
    });
  }
  public InitFilterOnWalets(){
    this.wallets = [];
    this.walletTypeOptions = [];
    this.walletTypeOptions.push({label: "Все валюты"});
    this.setLoading(true);   
    this.cryptoService.getCurrenciesNames()
      .then((resp)=>{
       this.wallets = resp.data;
       this.setWalletOptions(this.wallets);
       this.setLoading(false);
      })
      .catch((error) => {
        this.setLoading(false);
        console.error(error.error);
      });

  }
}




// WEBPACK FOOTER //
// ./src/app/transactions/transactions.component.ts